import { useAppSelector } from '../../../hooks/useRedux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { errorSelector } from '../../../state/workflow/workflow.selectors';
import { Col } from 'react-bootstrap';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';

interface SingleProgressProps {
  item: { label: string; id: number };
  activeStep: number;
}

const SingleProgress = ({ item, activeStep }: SingleProgressProps) => {
  const error = useAppSelector(errorSelector);

  const activeStepClassName = item.id === activeStep ? 'circle-active' : 'circle';

  const errorStepClassName = item.id === activeStep ? 'circle-completed ' : 'circle';

  const renderCircle = () => {
    if (error && activeStep === item.id) {
      return (
        <FontAwesomeIcon
          icon={faXmark}
          className={errorStepClassName}
          style={{ width: '14px', height: '14px' }}
        />
      );
    }
    if (activeStep > item.id) {
      return (
        <FontAwesomeIcon
          icon={faCheck}
          className="circle-completed"
          style={{ width: '14px', height: '14px' }}
        />
      );
    } else {
      return <div className={activeStepClassName} />;
    }
  };

  return (
    <Col className="px-1">
      <div className="circle-container d-flex justify-content-center justify-content-md-start">
        {renderCircle()}
        <div className="d-flex flex-column align-items-start ps-2 text-purple">
          <div className="fw-bolder">Step {item.id + 1}</div>
          <div className="text-start d-none d-md-block">{item.label}</div>
        </div>
      </div>
    </Col>
  );
};

export default SingleProgress;
